<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.platformStatus === 'C'
              ? 'primary'
              : row.platformStatus === 'S'
              ? 'warning'
              : row.platformStatus === 'Y'
              ? 'success'
              : 'danger'
          "
        >
          {{ row.v_platformStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.showMenu(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:createBy="{ row }">
        <span>
          {{ row.createByName }}
        </span>
        <br />
        <span>
          {{ row.createDate }}
        </span>
      </template>
      <template v-slot:modifyBy="{ row }">
        <span>
          {{ row.modifyByName }}
        </span>
        <br />
        <span>
          {{ row.modifyDate }}
        </span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { platformCode } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            code: platformCode,
          })
          break
        case 'delete':
          this.del(platformCode)
          break
        case 'submit':
          this.submit(platformCode)
          break
        case 'review':
          this.$emit('openEditPage', {
            pageType: menuType,
            code: platformCode,
          })
          break
      }
    },
    async submit(platformCode) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_submitOrder') || '是否提交审核？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomEvgPlatformSubmitApi({ platformCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.$emit('reload')
    },

    del(code) {
      this.$confirm(
        this.$l('tips_delete') || '是否要删除该记录？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomEvgPlatformDelApi({ platformCode: code }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
